import { PageLink, PageTitle } from '_metronic/layout/core';
import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { Avieww } from './components/aview';


const AsignacionBonosPage: FC = () => {
  let location = useLocation();
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Nómina',
      path: location.pathname,
      isSeparator: false,
      isActive: true,
      
    },
    {
      title: 'Asignación de bonos',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Asignación de bonos</PageTitle>
      <Avieww/>
    </>
  );
};

export {AsignacionBonosPage}